<div class="table-title">
    <div class="config-title">
        Importação
    </div>
    <div class="config-description">
        <div *ngIf="(currentStep$ | async) === 1">
            <span>Importe uma tabela de produtos e serviços em formato XLS, XLSX ou CSV.</span>
            <div class="import-tips">
                <span class="import-tips-title">Boas práticas para uma importação sem erros:</span>
                <ul>
                    <li>A primeira linha da planilha deve conter o nome das colunas: <strong>CÓDIGO, NOME, VALOR,
                            UNIDADE, CATEGORIA e DESCRIÇÃO</strong>.</li>
                    <li>Use uma linha para cada produto ou serviço, sem linhas em branco, células mescladas, fórmulas
                        ou linhas de total.</li>
                    <li>A coluna <strong>NOME</strong> é obrigatória. As demais são opcionais.</li>
                    <li>Preencha o <strong>VALOR</strong> apenas com números, sem "R$" e sem separador de milhar
                        (ex.: 1500,90).</li>
                    <li>Use um <strong>CÓDIGO</strong> único para cada item. Se o código já existir no sistema, o
                        produto será atualizado com os dados da planilha.</li>
                    <li>Em <strong>UNIDADE</strong> e <strong>CATEGORIA</strong>, prefira os nomes já cadastrados
                        no sistema. Nomes que ainda não existirem serão criados automaticamente.</li>
                    <li>O arquivo deve ter no máximo 10 MB.</li>
                </ul>
                <a class="import-example-link" (click)="downloadExampleFile()">
                    <mat-icon>file_download</mat-icon>
                    Baixar planilha de exemplo
                </a>
            </div>
        </div>
        <span *ngIf="(currentStep$ | async) === 2">
            Mapeie as colunas do arquivo para os campos do sistema. A coluna produto é obrigatória.
        </span>
        <span *ngIf="(currentStep$ | async) === 3">
            Aguarde enquanto o sistema processa a importação.
        </span>
        <span *ngIf="(currentStep$ | async) === 4">
            A importação foi concluída.
        </span>
    </div>
</div>
<div class="container" style="width: 100%; background-color: white; border-radius: 8px;">
    <div class="step-component-container" style="width: 100%; align-items: stretch;">
        <div class="steps-container" fxFlex="20" fxLayout="column">
            <div *ngFor="let step of steps; let i = index" class="step" [class.current]="(currentStep$ | async) === i+1"
                [class.completed]="(currentStep$ | async) > i+1">
                <div class="step-number">{{i+1}}</div>
                <div class="step-line" *ngIf="i !== steps.length - 1"></div>
                <span class="step-text">{{step}}</span>
            </div>
        </div>
        <div class="steps-content" fxFlex="80" fxLayout="column">
            <div *ngIf="(currentStep$ | async) === 1" style="height: 100%;">
                <app-file-input-component *ngIf="(currentStep$ | async) != steps.length" [state]="currentFileState"
                    [label]="currentFileLabel" (fileSelected)="onFileSelected($event)"></app-file-input-component>
            </div>
            <div class="step-column-selection-content" *ngIf="(currentStep$ | async) === 2" fxLayout="row"
                fxLayoutGap="16px">
                <form [formGroup]="columnsMatchForm" fxFlex="50" fxLayout="column" fxLayoutAlign="center start">

                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Nome</mat-label>
                        <mat-icon matSuffix class="secondary-text">
                            handyman
                        </mat-icon>
                        <mat-select formControlName="nome" required
                            (selectionChange)="updateColumnData('nome', $event.value)">
                            <mat-option *ngFor="let column of fileColumns" [value]="column">{{column}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Código</mat-label>
                        <mat-icon matSuffix class="secondary-text">
                            qr_code
                        </mat-icon>
                        <mat-select formControlName="codigo"
                            (selectionChange)="updateColumnData('codigo', $event.value)">
                            <mat-option *ngFor="let column of fileColumns" [value]="column">{{column}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Valor</mat-label>
                        <mat-icon matSuffix class="secondary-text">
                            price_change
                        </mat-icon>
                        <mat-select formControlName="valor" (selectionChange)="updateColumnData('valor', $event.value)">
                            <mat-option *ngFor="let column of fileColumns" [value]="column">{{column}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Unidade</mat-label>
                        <mat-icon matSuffix class="secondary-text">
                            perm_data_setting
                        </mat-icon>
                        <mat-select formControlName="unidade"
                            (selectionChange)="updateColumnData('unidade', $event.value)">
                            <mat-option *ngFor="let column of fileColumns" [value]="column">{{column}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Categoria</mat-label>
                        <mat-icon matSuffix class="secondary-text">
                            category
                        </mat-icon>
                        <mat-select formControlName="categoria"
                            (selectionChange)="updateColumnData('categoria', $event.value)">
                            <mat-option *ngFor="let column of fileColumns" [value]="column">{{column}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Descrição</mat-label>
                        <mat-icon matSuffix class="secondary-text">
                            info
                        </mat-icon>
                        <mat-select formControlName="descricao"
                            (selectionChange)="updateColumnData('descricao', $event.value)">
                            <mat-option *ngFor="let column of fileColumns" [value]="column">{{column}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </form>
                <div fxFlex="50" fxLayout="column">
                    <div class="rows columns-rows mt-16">
                        <div class="column-control row-content text-ellipsis" #columnControlCodigo>
                            <div *ngFor="let data of codigo" class=" text-ellipsis">{{data}}</div>
                        </div>
                        <div class="column-control row-content text-ellipsis" #columnControlNome>
                            <div *ngFor="let data of nome" class=" text-ellipsis">{{data}}</div>
                        </div>
                        <div class="column-control row-content text-ellipsis" #columnControlValor>
                            <div *ngFor="let data of valor" class=" text-ellipsis">{{data}}</div>
                        </div>

                        <div class="column-control row-content text-ellipsis" #columnControlValor>
                            <div *ngFor="let data of unidade" class=" text-ellipsis">{{data}}</div>
                        </div>

                        <div class="column-control row-content text-ellipsis" #columnControlValor>
                            <div *ngFor="let data of categoria" class=" text-ellipsis">{{data}}</div>
                        </div>

                        <div class="column-control row-content text-ellipsis" #columnControlValor>
                            <div *ngFor="let data of descricao" class=" text-ellipsis">{{data}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="(currentStep$ | async) === 3 " class="dotted-container" style="width: 100%;">
                <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                    <div class="spinner-container">
                        <div
                            style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                            <mat-spinner diameter="50"></mat-spinner>
                            <h3 style="text-align: center; padding: 0; margin: 0;">A importação está sendo processada.
                                Você pode navegar pelo sistema enquanto isso.</h3>
                            <h3 style="text-align: center; padding: 0; margin: 0;">Te avisaremos ao concluir.</h3>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="(currentStep$ | async) === 4" class="dotted-container dotted-success" style="width: 100%;">
                <div
                    style="width: 100%; height: 100%; gap:8px; flex-direction: column; display: flex; justify-content: center; align-items: center;">
                    <mat-icon class="font-size-xlg color-success w-60-px h-60-px">check_circle</mat-icon>
                    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                        <span class="color-success"><strong>{{createdCount}} produtos criados</strong></span>
                        <span class="color-updated"><strong>{{updatedCount}} produtos atualizados</strong></span>
                        <span class="color-error"><strong>{{errorCount}} erros</strong></span>
                    </div>

                    <span *ngIf="!showDetails" class="text-show-details mt-8" (click)="showDetails = !showDetails">Ver
                        detalhes</span>
                    <span *ngIf="showDetails" class="text-show-details mt-8"
                        (click)="showDetails = !showDetails">Ocultar detalhes</span>
                    <!-- Detail of import collapser -->
                    <div *ngIf="showDetails" class="details mt-8">
                        <div
                            style="width: 100%; height: 100%; gap:8px; flex-direction: column; display: flex; justify-content: center; align-items: center;">
                            <ng-container *ngIf="errorMessages.length > 0">
                                <div *ngFor="let error of errorMessages" class="color-error text-bold">
                                    <span>Em {{error.count}} </span>
                                    <span *ngIf="error.count > 1">registros: </span>
                                    <span *ngIf="error.count === 1">registro: </span>
                                    <span>{{error.message}}</span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Botões do DS: Anterior ghost + Próximo/Finalizar primary -->
    <div class="buttons-container mt-8">
        <button *ngIf="(currentStep$ | async) != steps.length && (currentStep$ | async) != 3" type="button"
            class="oa-btn oa-btn--ghost" (click)="prev()" [disabled]="(currentStep$ | async) === 1 || loading">
            <mat-icon>arrow_back</mat-icon>
            <span>Anterior</span>
        </button>
        <button *ngIf="(currentStep$ | async) != steps.length" type="button" class="oa-btn oa-btn--primary next-button"
            (click)="next()" [disabled]="(currentStep$ | async) === steps.length || disabled || loading"
            [attr.aria-busy]="loading || null">
            <span>Próximo</span>
            <mat-icon>arrow_forward</mat-icon>
            <span *ngIf="loading" class="oa-spinner" aria-hidden="true"></span>
        </button>
        <button *ngIf="(currentStep$ | async) == steps.length" type="button" class="oa-btn oa-btn--primary"
            (click)="navigateToProducts()">
            <span>Finalizar</span>
        </button>
    </div>
</div>